import * as BigJs from 'big.js';

export const bigConstructor: BigJs.BigConstructor = (BigJs as any).default || Big;
